import React from "react";
import { Navbar } from 'react-bootstrap';
import syncartoMapTogether from '../../assets/img/datum_landscan_logo.png';


export const Logo = ({ currentUser, context }: {currentUser: any, context:any}) => {
    console.log("context", context);
    let navCustomStyle = {
        backgroundColor: (currentUser) 
                                ? (currentUser.orgLogoBground ? currentUser.orgLogoBground : '#343a40') : '#343a40'
    };    
    let logoStyle;
    if (context){
        logoStyle = {
            height:"50px"
        };
    }else{
        logoStyle = {
            height:"100%",
            maxWidth:"100%"
        };
    }
    return (    
    <div className="d-flex justify-content-around nav navbar-logo-parent py-1" style={navCustomStyle}>
        <a href="/">
            <Navbar.Brand>
                <img
                src={ //Check if image exists as base 64 in the org table. If not, use default syncarto logo.
                    (currentUser)
                    ? (currentUser.orgLogo)
                        ? currentUser.orgLogo
                        : syncartoMapTogether
                    : syncartoMapTogether
                }
                style={logoStyle}
                className="d-inline-block align-middle logo-padding"
                alt={(currentUser)
                    ? (currentUser.orgName)
                    ? currentUser.orgName
                    : "Datum"
                    : "Datum"
                }
                />
                {``}
            </Navbar.Brand>
        </a>
    </div>
    );
}
